// The criteria the report detail narrows its movements by (caiet UC93-10), and the one predicate
// both the screen's table and the bff's export apply, so the file holds exactly the rows on screen
// (UC93-11). Design: docs/shape-ops-report-export.md §3 D2.

export interface MovementFilter {
  // A case-insensitive substring of the medicine code, the medicine name or the lot; '' for any.
  search: string;
  // One movement reason, exact; '' for any.
  reason: string;
}

export interface FilterableMovement {
  medicineCode: string;
  medicineName?: string | undefined;
  lot: string;
  reason: string;
}

export function matchesMovementFilter(row: FilterableMovement, filter: MovementFilter): boolean {
  if (filter.reason && row.reason !== filter.reason) return false;
  const needle = filter.search.trim().toLowerCase();
  if (!needle) return true;
  return (
    row.lot.toLowerCase().includes(needle) ||
    row.medicineCode.toLowerCase().includes(needle) ||
    (row.medicineName ?? '').toLowerCase().includes(needle)
  );
}
